import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import MainLayout from '@/components/layout/MainLayout';
import HomePage from '@/pages/home/page';
import NotFound from '@/pages/NotFound';
import PrivacyPolicyPage from '@/pages/legal/PrivacyPolicyPage';
import TermsConditionsPage from '@/pages/legal/TermsConditionsPage';
import MinorConsentFormPage from '@/pages/legal/MinorConsentFormPage';

export const routes: RouteObject[] = [
  {
    element: <MainLayout />,
    children: [
      {
        path: '/',
        element: <HomePage />,
      },
      {
        path: '/privacy-policy',
        element: <PrivacyPolicyPage />,
      },
      {
        path: '/term-conditions',
        element: <TermsConditionsPage />,
      },
      {
        path: '/minor-consent-form',
        element: <MinorConsentFormPage />,
      },
      {
        path: '/minor-concent-form',
        element: <Navigate to="/minor-consent-form" replace />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
];